import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_md,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const row = css`
  border-bottom: 1px solid ${base_colorContentBorder};

  &:last-of-type {
    border-bottom: none;
  }
`

export const rowContent = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(4)};
  width: 100%;
  min-height: 64px;
  padding: ${spacing(3)} ${spacing(2)};
`

export const period = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  min-width: 0;
`

export const periodTitle = css`
  font-size: ${font_size_md};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
`

export const periodDetail = css`
  font-size: ${font_size_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

/**
 * The failure line under a row whose download did not arrive.
 *
 * Sits below the row content rather than inside the action group so a long
 * sentence cannot squeeze the pill, amount, and controls out of alignment.
 *
 * Secondary text, matching the tab's other failure copy rather than shouting in
 * a severe colour: the sentence itself carries the message, and colour is never
 * the signal (`src/CLAUDE.md`).
 */
export const downloadError = css`
  margin: 0;
  padding: 0 ${spacing(2)} ${spacing(3)};
  font-size: ${font_size_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const rowActions = css`
  display: flex;
  align-items: center;
  gap: ${spacing(4)};
  flex: 0 0 auto;
`

export const amount = css`
  font-size: ${font_size_md};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
  font-variant-numeric: tabular-nums;
  /* min-width, not width: seven-figure statement balances are real on corporate
     cards and would otherwise overflow the box rather than widen it. */
  min-width: 90px;
  text-align: right;
`
